import { IField } from '../config';

export interface IServiceNow {
  client_id: string;
  client_secret: string;
  url: string;
  user_name: string;
  password: string;
  refresh_token: string;
  configuration_name: string;
}

export const FIELDS: IField[] = [
  {
    label: 'Integration Name',
    field: 'configuration_name',
    errorText: 'At lease 3 characters'
  },
  {
    label: 'ServiceNow Server URL',
    field: 'server_url'
  }
];

export const ID_PASSWORD: any = [
  {
    label: 'User ID for the intended user',
    field: 'user_name'
  },
  {
    label: 'Password',
    field: 'password',
    isPassword: true
  }
];

export const TOKEN: IField[] = [
  {
    label: '0Auth Client ID',
    field: 'client_id'
  },
  {
    label: '0Auth Client Secret',
    field: 'client_secret'
  },
  {
    label: 'Refresh Token',
    field: 'refresh_token',
    isPassword: true
  }
];
